import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Link from "gatsby-link";

function isString(str) {
  return typeof str === "string";
}

export default class Step extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    prefixCls: PropTypes.string,
    style: PropTypes.object,
    wrapperStyle: PropTypes.object,
    itemWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    status: PropTypes.string,
    iconPrefix: PropTypes.string,
    icon: PropTypes.node,
    iconProcess: PropTypes.node,
    iconWait: PropTypes.node,
    iconFinish: PropTypes.node,
    adjustMarginRight: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    stepNumber: PropTypes.string,
    description: PropTypes.any,
    title: PropTypes.any,
    url: PropTypes.string,
    progressDot: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    tailContent: PropTypes.any
  };
  renderIconNode() {
    const {
      prefixCls,
      progressDot,
      stepNumber,
      status,
      title,
      url,
      description,
      icon,
      iconProcess,
      iconWait,
      iconFinish,
      iconPrefix
    } = this.props;
    let iconNode;
    const iconClassName = classNames(`${prefixCls}-icon`, `${iconPrefix}icon`, {
      [`${iconPrefix}icon-${icon}`]: icon && isString(icon),
      [`${iconPrefix}icon-check`]: !icon && status === "finish",
      [`${iconPrefix}icon-cross`]: !icon && status === "error"
    });
    const iconDot = <span className={`${prefixCls}-icon-dot`} />;
    // `progressDot` enjoy the highest priority
    if (progressDot) {
      if (typeof progressDot === "function") {
        iconNode = (
          <span className={`${prefixCls}-icon`}>
            {progressDot(iconDot, {
              index: stepNumber - 1,
              status,
              title,
              description
            })}
          </span>
        );
      } else {
        iconNode = <span className={`${prefixCls}-icon`}>{iconDot}</span>;
      }
    } else if (icon && !isString(icon)) {
      iconNode = <span className={`${prefixCls}-icon`}>{icon}</span>;
    } else if (icon || status === "finish" || status === "error") {
      iconNode = <span className={iconClassName} />;
    } else {
      iconNode = <span className={`${prefixCls}-icon`}>{stepNumber}</span>;
    }
    return iconNode;
  }
  render() {
    const {
      className,
      prefixCls,
      style,
      itemWidth,
      status = "wait",
      iconPrefix,
      icon,
      wrapperStyle,
      iconProcess,
      iconWait,
      iconFinish,
      adjustMarginRight,
      stepNumber,
      description,
      title,
      url,
      progressDot,
      tailContent,
      ...restProps
    } = this.props;

    const classString = classNames(
      `${prefixCls}-item`,
      "Step",
      `Step--${status}`,
      `${prefixCls}-item-${status}`,
      className,
      { [`${prefixCls}-item-custom`]: icon }
    );
    const stepItemStyle = { ...style };
    if (itemWidth) {
      stepItemStyle.width = itemWidth;
    }
    if (adjustMarginRight) {
      stepItemStyle.marginRight = adjustMarginRight;
    }
    return (
      <div {...restProps} className={classString} style={stepItemStyle}>
        <Link className="StepLink" to={url}>
          <div className={`${prefixCls}-item-tail Step__tail`}>
            {tailContent}
          </div>

          <div className="Step__fab">
            {status === "process" ? <div className="Step__fab-loader" /> : null}

            <span className="Step__fab-icon">
              {(() => {
                switch (status) {
                  case "process":
                    return iconProcess;
                  case "finish":
                    return iconFinish;
                  case "wait":
                    return iconWait;
                  default:
                    return null;
                }
              })()}
            </span>
          </div>

          <div className={`${prefixCls}-item-content Step__content`}>
            <div className={`${prefixCls}-item-title Step__title`}>{title}</div>

            {description && (
              <div
                className={`${prefixCls}-item-description Step__description`}
              >
                {description}
              </div>
            )}
          </div>
        </Link>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Step.js